import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Col, Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { FaSearch, FaTimes } from 'react-icons/fa';     
import { useLocation, useNavigate } from "react-router-dom";
import { getApiHeader } from 'utlis/commonfunctions';
import banner from "assets/images/international_esim_banner.png";
import { Backdrop, CircularProgress } from "@mui/material";
import PlanDetailsCard from "../PlanDetailsCard";
import BannerSection from "../BannerSection";



const SERVER_URL = process.env.REACT_APP_API_URL;


const CountryPlanList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // const { country } = location.state || {};
    
    const [country , setCountry ] = useState({})
    
    const [showModal, setShowModal] = useState(false);

    const [selectedCountry, setSelectedCountry] = useState(null);
    const [isLoadingCountryPlanList, setIsLoadingCountryPlanList] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedPlanSlug, setSelectedPlanSlug] = useState('');
    const [is_telsim_plan, setIsTelsimPlan] = useState(false)
    const [selectedCountryDetail, setSelectedCountryDetail] = useState(null);
    const [selectedCountryTheme, setSelectedCountryTheme] = useState("");
    const [error, setError] = useState(null);
    const [selectedCountryPlanList, setSelectedCountryPlanList] = useState([]);
    const [retailerType , setRetailerType] = useState("PID");
    
    const cardStyles = {
        background: `linear-gradient(to top, ${selectedCountryTheme.top || '#D6060D'} 0%, ${selectedCountryTheme.bottom || '#000'} 100%)`,
        color: 'white'
    };
    const cardTopStyles = {
        background: `transparent`,
        color: 'white',
        fontWeight: '500',
        textTransform: 'uppercase'
    };

    const buttonStyle = {
        background: `${selectedCountryTheme.button}`,
        color: 'white',
        border: '2px solid #ccc',
        Cursor: 'pointer'
    }

    const fetchCountryPlanList = async (country_name_slug) => {
        setSelectedCountry(country_name_slug);
        setIsLoadingCountryPlanList(true);

        let res = '';
        try {
            await new Promise(resolve => setTimeout(resolve, 2000));

            const headers = await getApiHeader();
            res = await axios.get(`${SERVER_URL}international-esim/plans/${country_name_slug}`, {
                headers: headers
            });

            if (res.status === 200) {
                const planData = res.data.data;
                 
                if (planData && planData.plans) {
                    setSelectedCountryPlanList(planData.plans);
                    
                } else {
                    console.error('Unexpected response structure:', res.data);
                    return;
                }
                const data =  planData.country_region_data
                const themeData =   data.theme_class
                setRetailerType(res.data.data.retailer_type)
                

                if (data) {
                    const themeClass = JSON.parse(themeData);
                    setSelectedCountryTheme(themeClass);

                    setSelectedCountryDetail(data);

                } else {
                    console.error('Country information is missing in the response:', res.data);
                }
            } else {
                console.error('Error: Unexpected status code', res.status);
            }
        } catch (error) {

            console.error('Error fetching country plan list:', error.status);

            setError(400);

        } finally {
            setIsLoadingCountryPlanList(false);
        }
    };

    const handleCardClick = (plan) => {
        setSelectedPlanSlug(plan.plan_slug);
        // navigate("/international_esim/plan_details", { state: { planSlug: plan.plan_slug, plan }, replace: true });
        setShowModal(true);

    };


    const handleCloseModal = () => {
        // navigate(-1);
        setShowModal(false);
    };
    
   
    
    useEffect(() => {
        if (location.state?.country) {
            setCountry(location.state.country); 
    
        } else {
            console.warn('No country provided in location.state');
           
        }
    }, [location.state]);
    
    useEffect(() => {
        if (country?.country_name_slug) {
            fetchCountryPlanList(country.country_name_slug); // Fetch once `country` is updated
        }
    }, [country]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {/* <div
                className="col-md-12 w-100"
                style={{
                    backgroundImage: `url(${banner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '450px',
                    position: 'relative'
                }}
            >
                <div className="search-bar"
                    style={{
                        position: 'absolute',
                        bottom: '10px',
                        left: '31%',
                        transform: 'translateX(-50%)',
                        padding: '18px',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        width: "800px"
                    }}
                >
                    <FaSearch className="search-icon" style={{ marginRight: '8px' }} />
                    <input
                        type="text"
                        placeholder="Search data packs for 200+ countries and regions"
                        value=""
                        className="search-input"
                        translate="no"
                        style={{
                            border: 'none',
                            outline: 'none',
                            padding: '4px 8px',
                            borderRadius: '4px'
                        }}
                    />
                </div>
            </div>
            <br></br> */}
           
            <div className='container-fluid'>
            <BannerSection country={country}  cardStyles={cardStyles}/>
            <br></br>
                <Container>
                    <Row className="mt-4">
                        {selectedCountry ? (
                            <>
                                {isLoadingCountryPlanList ? (
                                    <Backdrop
                                        open={true}
                                        style={{
                                            color: '#fff',
                                            zIndex: 9999,
                                        }}
                                    >
                                        <CircularProgress color="inherit" />
                                    </Backdrop>
                                ) : (
                                    <>
                                        {selectedCountryPlanList.length > 0 ? (
                                            selectedCountryPlanList.map((plan, index) => (
                                                <Col xs={12} sm={12} md={6} lg={4} className="mb-4 mt-1" key={index}>
                                                    <div className="card global-plan-card" style={cardStyles}>
                                                        <div
                                                            className="card-header d-flex justify-content-between align-items-center px-2"
                                                            translate="no"
                                                            style={cardTopStyles}
                                                        >
                                                            {plan.common_plan_name}
                                                            <img src={plan.plan_image} alt={plan.img_alt} title={plan.img_title} />
                                                        </div>
                                                        <div className="card-body" style={cardStyles}>
                                                            <b>
                                                                <i className="fas fa-globe" style={{ margin: "3px"}}></i>Coverage{' '}
                                                                <span translate="no">
                                                                    { selectedCountryDetail.short_name || selectedCountryDetail.name}
                                                                </span>
                                                            </b>
                                                            <hr />
                                                            <b>
                                                                <i className="fas fa-arrow-up" style={{ margin: "3px"}}></i>Data{' '}
                                                                <span>{plan.plan_data ?? ''} GB</span>
                                                            </b>
                                                            <hr />
                                                            <b>
                                                                <i className="fas fa-calendar-alt" style={{ margin: "3px"}}></i>Validity{' '}
                                                                <span>
                                                                    {plan.plan_validity
                                                                        ? `${plan.plan_validity} ${plan.plan_validity === 1 ? 'Day' : 'Days'}`
                                                                        : ''}
                                                                </span>
                                                            </b>
                                                            <hr />
                                                            <b>
                                                                <i className="fas fa-tag" style={{ margin: "3px"}}></i>&nbsp; Price{' '}
                                                                <span>
                                                                   AU $ {retailerType === "PAR" ? (plan.prosegur_amount ?? '') : plan.rtap_amount}
                                                                </span>
                                                            </b>
                                                            <hr />
                                                           
                                                            <button
                                                                className="btn btn-custom btn-block value-btn"
                                                                style={buttonStyle}
                                                                onClick={() => handleCardClick(plan)}
                                                            >
                                                              AU $ {retailerType === "PAR" ? (plan.prosegur_amount ?? '') : plan.plan_amount}  -  Buy Now
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))
                                        ) : (
                                            <p>No plans available</p>
                                        )}
                                    </>
                                )}
                            </>
                        ) : (
                            <p>Select a country to view plans.</p>
                        )}
                    </Row>

                </Container>

            </div>

            {showModal && (
                <PlanDetailsCard countryProps={country} show={showModal} is_telsim_plan={is_telsim_plan ? 1 : 0} button={selectedCountryTheme.button} top={selectedCountryTheme.top} bottom={selectedCountryTheme.bottom} countrySlug={country.country_name_slug} planSlug={selectedPlanSlug} retailerType={retailerType}  handleClose={handleCloseModal} />
            )}
        </DashboardLayout>
    );
};

export default CountryPlanList;